module.exports = __webpack_public_path__ + "img/basemap_google.46dc8ce0.png";